import * as React from 'react'
import { JsTree } from '../../../../components/ui/JsTree';
import { NewProjectHttp } from '../../http';
import { IJsTreeCoreDataNode, ISegmentReference } from '../../interfaces';

interface IHierarchyJsTreeProps {
  values: ISegmentReference[]
  onChange: (values: ISegmentReference[]) => void
  project?: string
  required?: boolean
}

interface IHierarchyJsTreeState {
  selected: string[]
  segments: ISegmentReference[]
  data: IJsTreeCoreDataNode[]
}

export class SegmentJsTree extends React.Component<IHierarchyJsTreeProps, IHierarchyJsTreeState> {
  state: IHierarchyJsTreeState = {
    selected: [],
    segments: [],
    data: []
  }

  lastProject = ''

  componentWillMount() {
    this.loadSegmentNodes()
  }

  componentWillReceiveProps(nextProps: IHierarchyJsTreeProps) {
    this.loadSegmentNodes(nextProps)
  }

  loadSegmentNodes(props = this.props) {
    const { project, values } = props
    const selected = values.map((value) => value.avid)

    this.setState({ selected })

    if (this.lastProject === project) {
      return
    }

    this.lastProject = project
    this.setState({ data: undefined })

    NewProjectHttp.getSegments(project).then((projectSegments) => {
      const segments = projectSegments[0].segmentReferences
      const data = NewProjectHttp.mapSegmentsToJsTreeNodes(segments)

      this.setState({ segments, data })
    })
  }

  onChange(selected: string[]) {
    const { segments } = this.state

    const values: ISegmentReference[] = selected.map((avid) => {
      return segments.find((hierarchy) => hierarchy.avid === avid)
    })

    this.props.onChange(values)
  }

  render() {
    const { project } = this.props
    const { data } = this.state
    const error = () => { /**/ }
    const segmentOptions: JSTreeStaticDefaults = {
      plugins: ['wholerow', 'checkbox'],
      core: { error, data }
    }

    if (!project || !data) {
      return (
        <small>Loading Segments...</small>
      )
    }

    return (
      <section style={{ position: 'relative' }}>
        <input type="text" style={{ position: 'absolute', top: 15, left: 50, height: 1, width: 1, opacity: 0 }}
          required={this.props.required}
          value={this.props.values.length > 0 ? 'defined' : ''}
        />
        <article style={{ minHeight: 275, maxHeight: 275, overflowY: 'auto' }}>
          <JsTree
            options={segmentOptions}
            selected={this.state.selected}
            onChange={(selected) => this.onChange(selected)}
          />
        </article>
      </section>
    )
  }
}
